var map = {
	"Admin/dashboard/dashboard.module": [
		"./src/app/Admin/ngx/dashboard/dashboard.module.ts",
		"Admin-dashboard-dashboard-module"
	],
	"Admin/layout/layout.module": [
		"./src/app/Admin/ngx/layout/layout.module.ts",
		"common",
		"Admin-layout-layout-module"
	],
	"Admin/login/login.module": [
		"./src/app/Admin/ngx/login/login.module.ts",
		"Admin-login-login-module"
	],
	"Admin/not-found/not-found.module": [
		"./src/app/Admin/ngx/not-found/not-found.module.ts",
		"Admin-not-found-not-found-module"
	],
	"Admin/pages/configuration/nav/configuration.nav.module": [
		"./src/app/Admin/ngx/pages/configuration/nav/configuration.nav.module.ts",
		"Admin-pages-configuration-nav-configuration-nav-module"
	],
	"Admin/pages/store/general/general.module": [
		"./src/app/Admin/ngx/pages/store/general/general.module.ts",
		"Admin-pages-store-general-general-module"
	],
	"Admin/pages/store/payment/payment.module": [
		"./src/app/Admin/ngx/pages/store/payment/payment.module.ts",
		"Admin-pages-store-payment-payment-module"
	],
	"Admin/signup/signup.module": [
		"./src/app/Admin/ngx/signup/signup.module.ts",
		"Admin-signup-signup-module"
	],
	"AdminPermission/apcpage/apc.module": [
		"./src/app/AdminPermission/ngx/apcpage/apc.module.ts",
		"AdminPermission-apcpage-apc-module"
	],
	"AdminSales/pages/bulkinvoice-pdf/bulkinvoice-pdf.module": [
		"./src/app/AdminSales/ngx/pages/bulkinvoice-pdf/bulkinvoice-pdf.module.ts",
		"default~AdminSales-pages-bulkinvoice-bulkinvoice-module~AdminSales-pages-bulkinvoice-pdf-bulkinvoice~ce8560b5",
		"common",
		"AdminSales-pages-bulkinvoice-pdf-bulkinvoice-pdf-module"
	],
	"AdminSales/pages/bulkinvoice/bulkinvoice.module": [
		"./src/app/AdminSales/ngx/pages/bulkinvoice/bulkinvoice.module.ts",
		"default~AdminSales-pages-bulkinvoice-bulkinvoice-module~AdminSales-pages-bulkinvoice-pdf-bulkinvoice~ce8560b5",
		"common",
		"AdminSales-pages-bulkinvoice-bulkinvoice-module"
	],
	"AdminSales/pages/coupon-report/coupon-report.module": [
		"./src/app/AdminSales/ngx/pages/coupon-report/coupon-report.module.ts",
		"common",
		"AdminSales-pages-coupon-report-coupon-report-module"
	],
	"AdminSales/pages/coupons/coupons.module": [
		"./src/app/AdminSales/ngx/pages/coupons/coupons.module.ts",
		"common",
		"AdminSales-pages-coupons-coupons-module"
	],
	"AdminSales/pages/customers/customers.module": [
		"./src/app/AdminSales/ngx/pages/customers/customers.module.ts",
		"common",
		"AdminSales-pages-customers-customers-module"
	],
	"AdminSales/pages/invoice-template-management/invoice-template-management.module": [
		"./src/app/AdminSales/ngx/pages/invoice-template-management/invoice-template-management.module.ts",
		"AdminSales-pages-invoice-template-management-invoice-template-management-module"
	],
	"AdminSales/pages/log-page/log-page.module": [
		"./src/app/AdminSales/ngx/pages/log-page/log-page.module.ts",
		"common",
		"AdminSales-pages-log-page-log-page-module"
	],
	"AdminSales/pages/mat-braintree-report/mat-braintree-report.module": [
		"./src/app/AdminSales/ngx/pages/mat-braintree-report/mat-braintree-report.module.ts",
		"default~AdminSales-pages-mat-braintree-report-mat-braintree-report-module~AdminSales-pages-mat-order~39798829",
		"common",
		"AdminSales-pages-mat-braintree-report-mat-braintree-report-module"
	],
	"AdminSales/pages/mat-orderreport/mat-orderreport.module": [
		"./src/app/AdminSales/ngx/pages/mat-orderreport/mat-orderreport.module.ts",
		"default~AdminSales-pages-mat-braintree-report-mat-braintree-report-module~AdminSales-pages-mat-order~39798829",
		"common",
		"AdminSales-pages-mat-orderreport-mat-orderreport-module"
	],
	"AdminSales/pages/orders/orders.module": [
		"./src/app/AdminSales/ngx/pages/orders/orders.module.ts",
		"default~AdminSales-pages-orders-orders-module~AdminSales-pages-returnitem-returnitem-module~DataImpo~0638aefa",
		"common",
		"AdminSales-pages-orders-orders-module"
	],
	"AdminSales/pages/preview-invoice-pdf/preview-invoice-pdf.module": [
		"./src/app/AdminSales/ngx/pages/preview-invoice-pdf/preview-invoice-pdf.module.ts",
		"AdminSales-pages-preview-invoice-pdf-preview-invoice-pdf-module"
	],
	"AdminSales/pages/returnitem/returnitem.module": [
		"./src/app/AdminSales/ngx/pages/returnitem/returnitem.module.ts",
		"default~AdminSales-pages-orders-orders-module~AdminSales-pages-returnitem-returnitem-module~DataImpo~0638aefa",
		"common",
		"AdminSales-pages-returnitem-returnitem-module"
	],
	"AdminSales/pages/search-customer/search-customer.module": [
		"./src/app/AdminSales/ngx/pages/search-customer/search-customer.module.ts",
		"AdminSales-pages-search-customer-search-customer-module"
	],
	"CMS/page/cmsmanagement.module": [
		"./src/app/CMS/ngx/page/cmsmanagement.module.ts",
		"common",
		"CMS-page-cmsmanagement-module"
	],
	"DataImporter/page/productimporter.module": [
		"./src/app/DataImporter/ngx/page/productimporter.module.ts",
		"default~AdminSales-pages-orders-orders-module~AdminSales-pages-returnitem-returnitem-module~DataImpo~0638aefa",
		"common",
		"DataImporter-page-productimporter-module"
	],
	"SEO/pages/pageseo/pageseo.module": [
		"./src/app/SEO/ngx/pages/pageseo/pageseo.module.ts",
		"common",
		"SEO-pages-pageseo-pageseo-module"
	],
	"UrlRewriter/page/urlrewritemgr.module": [
		"./src/app/UrlRewriter/ngx/page/urlrewritemgr.module.ts",
		"UrlRewriter-page-urlrewritemgr-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;